import { useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { BackButton, HomeButton } from "./assets/icons/icons";
import theme from "./theme";

const { sm, md } = theme.screen;

const NotFound: React.FC<{}> = () => {
  const navigate = useNavigate();

  // console.log(location);
  // console.log(window.location);

  return (
    <Wrapper>
      <Text404Container>
        <svg>
          <Text404 x="50%" y="50%" dy=".35em" textAnchor="middle">
            404
          </Text404>
        </svg>
      </Text404Container>

      <WarningMsg>찾으시는 페이지가 없습니다.</WarningMsg>
      <div style={{ textAlign: "center", lineHeight: "20px" }}>
        <Text>잘못된 접근이거나 요청하신 페이지를 찾을 수 없습니다.</Text>
        <Text>
          입력하신 페이지의 주소가 정확한지 다시 한번 확인해 주시기
          바랍니다.
        </Text>
      </div>

      <ButtonContainer>
        <Button onClick={() => navigate(-1)}>
          <BackButton />

          <ButtonText style={{ fontSize: "large" }}>뒤로가기</ButtonText>
        </Button>
        <Button onClick={() => navigate(`/`, { replace: true })}>
          <HomeButton />

          <ButtonText style={{ fontSize: "large" }}>
            홈으로 이동
          </ButtonText>
        </Button>
      </ButtonContainer>
    </Wrapper>
  );
};

const ButtonText = styled.span`
  font-size: large;
  @media (max-width: ${sm}px) {
    display: none;
  }
`;

const Wrapper = styled.div`
  width: 100vw;
  min-width: 320px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
  background-color: ${theme.color.white};
  overflow: hidden;

  @media (max-width: ${md}px) {
    height: calc(var(--vh, 1vh) * 100);
    min-width: 320px;
  }

  @media (max-width: ${sm}px) {
    min-height: -webkit-fill-available;
    position: fixed;
    @supports (-webkit-touch-callout: none) {
      height: -webkit-fill-available;
    }
  }
`;

const stroke = keyframes`
  0%   {
		fill: rgba(92,200,109,0); stroke: ${theme.color.green_600};
		stroke-dashoffset: 25%; stroke-dasharray: 0 50%; stroke-width: 2;
	}
	70%  {fill: rgba(92,200,109,0); stroke: ${theme.color.green_600}; }
	80%  {fill: rgba(92,200,109,0); stroke: ${theme.color.green_600}; stroke-width: 3; }
	100% {
		fill: ${theme.color.green_500}; stroke: rgba(78,170,92,0);
		stroke-dashoffset: -25%; stroke-dasharray: 50% 0; stroke-width: 0;
	}
`;

const Text404Container = styled.div`
  svg {
    font-family: "Russo One", sans-serif;
    width: 100%;
    height: 100%;
  }
  svg text {
    animation: ${stroke} 5s infinite alternate;
    stroke-width: 2;
    stroke: ${theme.color.green_600};
    font-family: "Russo One", sans-serif;
    font-size: 150px;

    @media (max-width: ${sm}px) {
      font-size: 100px;
    }
  }
`;
const Text404 = styled.text``;

const WarningMsg = styled.h1`
  font-size: 60px;
  color: ${theme.color.neutral_500};

  @media (max-width: ${sm}px) {
    font-size: 25px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    font-size: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 100px;

  @media (max-width: ${sm}px) {
    width: 100%;
    gap: 0px;
  }
`;
const Button = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: ${theme.color.green_500};
  font-weight: bold;
  transition: 200ms;

  &:hover {
    scale: 110%;
  }
  @media (max-width: ${sm}px) {
    width: 50%;
  }
`;

const Text = styled.p`
  padding: 0 20px;
  color: ${theme.color.neutral_500};
  font-size: 18px;
  @media (max-width: ${sm}px) {
    font-size: 14px;
  }

  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    font-size: 16px;
  }
`;

export default NotFound;
